export { ViewType2 as PortalPageViewType2 } from 'components/PortalPage/Sections/Type2/ViewType2';
export { ManageType2 as PortalPageManageType2 } from 'components/PortalPage/Sections/Type2/ManageType2';

export { ViewType3 as PortalPageViewType3 } from 'components/PortalPage/Sections/Type3/ViewType3';
export { ManageType3 as PortalPageManageType3 } from 'components/PortalPage/Sections/Type3/ManageType3';

export { ViewType4 as PortalPageViewType4 } from 'components/PortalPage/Sections/Type4/ViewType4';
export { ManageType4 as PortalPageManageType4 } from 'components/PortalPage/Sections/Type4/ManageType4';

export { ViewType5 as PortalPageViewType5 } from 'components/PortalPage/Sections/Type5/ViewType5';
export { ManageType5 as PortalPageManageType5 } from 'components/PortalPage/Sections/Type5/ManageType5';

export { ViewType6 as PortalPageViewType6 } from 'components/PortalPage/Sections/Type6/ViewType6';
export { ManageType6 as PortalPageManageType6 } from 'components/PortalPage/Sections/Type6/ManageType6';

export { ViewType7 as PortalPageViewType7 } from 'components/PortalPage/Sections/Type7/ViewType7';
export { ManageType7 as PortalPageManageType7 } from 'components/PortalPage/Sections/Type7/ManageType7';

export { ViewType8 as PortalPageViewType8 } from 'components/PortalPage/Sections/Type8/ViewType8';
export { ManageType8 as PortalPageManageType8 } from 'components/PortalPage/Sections/Type8/ManageType8';

export { ViewType9 as PortalPageViewType9 } from 'components/PortalPage/Sections/Type9/ViewType9';
export { ManageType9 as PortalPageManageType9 } from 'components/PortalPage/Sections/Type9/ManageType9';

export { ManageType10 as PortalPageManageType10 } from 'components/PortalPage/Sections/ManageType10';

export { ViewType11 as PortalPageViewType11 } from 'components/PortalPage/Sections/Type11/ViewType11';
export { ManageType11 as PortalPageManageType11 } from 'components/PortalPage/Sections/Type11/ManageType11';

export { ViewType12 as PortalPageViewType12 } from 'components/PortalPage/Sections/Type12/ViewType12';
export { ManageType12 as PortalPageManageType12 } from 'components/PortalPage/Sections/Type12/ManageType12';

export { PortalPageSectionRenderer } from 'components/PortalPage/Sections/SectionRenderer';
export { PortalPageSectionSelector } from 'components/PortalPage/Sections/SectionSelector';
